module.exports = __webpack_public_path__ + "static/media/orange_card_bg_ar.6197a678.png";